// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuickBookingSlots_wrapper___vaI3","slots":"QuickBookingSlots_slots__TH5r_","slot-error":"QuickBookingSlots_slot-error__sGFWy"};